export function getURLParam(sParam) {
  const params = new URLSearchParams(window.location.search)
  if (!params.has(sParam)) return undefined

  return params.get(sParam) === '' ? true : params.get(sParam)
}

export function isElementVisible(elm, threshold, mode) {
  threshold = threshold || 0
  mode = mode || 'visible'

  const rect = elm.getBoundingClientRect()

  const viewHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight
  )

  const above = rect.bottom - threshold < 0
  const below = rect.top - viewHeight + threshold >= 0

  if (mode === 'above') {
    return above
  } else if (mode === 'below') {
    return below
  } else {
    return !above && !below
  }
}

export function parseNumberInput(value) {
  return Number(value.replace(/\D/g, '')) || 0
}

// Reformats a text input as a whole number with thousands separators,
// keeping the caret after the same digits it followed before.
export function formatNumberInput(input) {
  const digitsBeforeCaret = input.value
    .slice(0, input.selectionStart).replace(/\D/g, '').length

  const digits = input.value.replace(/\D/g, '')

  input.value = digits ? Number(digits).toLocaleString('en-US') : ''

  let position = 0
  let seen = 0

  while (seen < digitsBeforeCaret && position < input.value.length) {
    if (/\d/.test(input.value[position])) seen += 1
    position += 1
  }

  input.setSelectionRange(position, position)
}

// For `beforeinput`. Deleting a separator alone would leave the digits
// unchanged, so step over it and let the deletion take the neighbouring
// digit instead.
export function skipNumberSeparator(event) {
  const input = event.target

  if (input.selectionStart !== input.selectionEnd) return

  const caret = input.selectionStart

  if (event.inputType === 'deleteContentBackward' &&
      input.value[caret - 1] === ',') {
    input.setSelectionRange(caret - 1, caret - 1)
  } else if (event.inputType === 'deleteContentForward' &&
             input.value[caret] === ',') {
    input.setSelectionRange(caret + 1, caret + 1)
  }
}
